<template>
  <div id="gallery">
    <div class="container">
      <Title :text="title"></Title>

      <div class="content">
        <div class="swiper-container" id="gallery-swiper">
          <div class="swiper-wrapper">
            <!-- <div class="swiper-slide wow fadeIn" data-wow-duration="1.3s">
              <img src="../../../assets/img/gallery/gallery (1).png" alt />
              <div class="kuang-wraaper">
                <div class="kuang"></div>
              </div>
            </div> -->
            <div class="swiper-slide wow fadeIn"  data-wow-duration="1.3s">
              <img src="../../../assets/img/gallery/gallery (2).png" alt />
              <div class="kuang-wraaper"> 
                <div class="kuang"></div>
              </div>
            </div>
            <div class="swiper-slide wow fadeIn"  data-wow-duration="1.3s">
              <img src="../../../assets/img/gallery/gallery (3).png" alt />
              <div class="kuang-wraaper">
                <div class="kuang"></div>
              </div>
            </div>
            <div class="swiper-slide wow fadeIn"  data-wow-duration="1.3s">
              <img src="../../../assets/img/gallery/gallery (4).png" alt />
              <div class="kuang-wraaper">
                <div class="kuang"></div>
              </div>
            </div>
            <div class="swiper-slide wow fadeIn"  data-wow-duration="1.3s">
              <img src="../../../assets/img/gallery/gallery (5).png" alt />
              <div class="kuang-wraaper">
                <div class="kuang"></div>
              </div>
            </div>
            <div class="swiper-slide wow fadeIn"  data-wow-duration="1.3s">
              <img src="../../../assets/img/gallery/gallery (6).png" alt />
              <div class="kuang-wraaper">
                <div class="kuang"></div>
              </div>
            </div>
            <div class="swiper-slide wow fadeIn"  data-wow-duration="1.3s">
              <img src="../../../assets/img/gallery/gallery (7).png" alt />
              <div class="kuang-wraaper">
                <div class="kuang"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import Title from "../title/Title2.vue";
import WOW from 'wowjs'   



export default {
  name: "Gallery",
  props: {},
  data() {
    return {
      title: "Gallery"
    };
  },
  mounted() {
    new WOW.WOW().init();
    new Swiper("#gallery-swiper", {
      spaceBetween: 30,
      slidesPerView: 3,
      mousewheel: true,
      loop: true,
      centeredSlides: true,
      centeredSlidesBounds: true
    });
  },
  components: {
    Title
  }
};
</script>

<style scoped lang="scss">
#gallery {
  background: url("../../../assets/img/gallery/bg.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: center;

  .swiper-slide {
    text-align: center;
    position: relative;
    img {
      width: 90%;
      height: 90%;
      margin: 0 auto;
    }
  
    .kuang-wraaper {
      width: 100%;
      height: 100%;
      padding: 0.545455rem;
      position: absolute;
      left: 0;
      top: 0;
      .kuang {
        width: 100%;
        height: 100%;
        border: .151515rem solid #ffffff;
      }
    }
      &:not(.swiper-slide-active) {
         .kuang-wraaper {
       padding: 1rem;
      }
      padding-top: 0.606061rem;
    }
  }

  .swiper-slide-active {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
